import { Component } from '@angular/core';

import * as Services from '@shared/core/services';

import { Error404Component as SharedError404Component } from '@shared/core/views/error404';

@Component({
    selector: 'app-error404',
    templateUrl: './error404.component.html',
    styleUrls: ['./error404.component.scss']
})
export class Error404Component extends SharedError404Component {
    constructor(
        public initService: Services.InitService,
    ) {
        super(initService);
    }
}
